import { concatMap } from "rxjs";
import { apiService } from "../../ApiService";
import { getUserInfo } from "./getUserInfo";

export type ChangeEmailFormData = {
  email: string;
  password: string;
};

export const updateEmail = (data: ChangeEmailFormData) => {
  return apiService
    .put({
      path: `v1/me/email`,
      body: data,
      requiresAuthPolicy: "user",
    })
    .pipe(concatMap(() => getUserInfo()));
};
